import "../../CommonImports";
import "../../Core/core.css";
import "./Header.css";
import * as React from "react";
import { css } from '../../Util';
export class HeaderTitleRow extends React.Component {
    render() {
        return React.createElement("div", { className: css(this.props.className, "bolt-header-title-row flex-row flex-baseline") }, this.props.children);
    }
}
